import {
  useEffect,
  useRef,
  useState,
} from 'react'


interface Station {
  id: string
  name: string
  subtitle: string
  url: string
}


const stations: Station[] = [
  {
    id: 'dronezone',
    name: 'Focus Mode',
    subtitle: 'Drone Zone',
    url:
      'https://ice1.somafm.com/dronezone-128-mp3',
  },
 
  {
    id: 'darksynth',
    name: 'Red Team Mode',
    subtitle: 'Dark Synth',
    url:
      'https://stream.rekt.network/darksynth.ogg',
  },

  {
    id: 'defcon',
    name: 'Blue Team Mode',
    subtitle: 'DEF CON',
    url:
      'https://ice1.somafm.com/defcon-128-mp3',
  },

  {
    id: 'darkzone',
    name: 'Dark Zone',
    subtitle: 'Dark Zone',
    url:
      'https://ice1.somafm.com/darkzone-128-mp3',
  },

]


export function RadioPlayer() {
  const audioRef =
    useRef<HTMLAudioElement>(null)


  const [selectedStation, setSelectedStation] =
    useState<Station>(() => {
      const saved =
        localStorage.getItem(
          'kraken-radio-station',
        )

      return (
        stations.find(
          (station) =>
            station.id === saved,
        )
        ??
        stations[0]
      )
    })


  const [playing, setPlaying] =
    useState(false)


  const [volume] =
    useState(() => {
      const saved =
        localStorage.getItem(
          'kraken-radio-volume',
        )

      return saved
        ? Number(saved)
        : 0.7
    })


  const [open, setOpen] =
    useState(false)



  useEffect(() => {
    localStorage.setItem(
      'kraken-radio-station',
      selectedStation.id,
    )

    const audio =
      audioRef.current

    if (!audio) {
      return
    }

    audio.src =
      selectedStation.url


    if (playing) {
      void audio.play()
    }

  }, [
    selectedStation,
  ])



  useEffect(() => {
    const audio =
      audioRef.current

    if (!audio) {
      return
    }

    audio.volume = volume

    localStorage.setItem(
      'kraken-radio-volume',
      String(volume),
    )

  }, [
    volume,
  ])



  async function togglePlay() {
    const audio =
      audioRef.current

    if (!audio) {
      return
    }


    if (playing) {

      audio.pause()

      setPlaying(false)

      return
    }


    try {

      await audio.play()

      setPlaying(true)

    } catch (error) {

      console.error(
        'Radio error:',
        error,
      )

    }
  }



  function changeStation(
    station: Station,
  ) {
    setSelectedStation(
      station,
    )

    setOpen(false)

    setPlaying(false)
  }



  return (
    <div className="kr-radio">

      <audio
        ref={audioRef}
        preload="none"
        onPause={() =>
          setPlaying(false)
        }
        onPlay={() =>
          setPlaying(true)
        }
      />


      <button
        type="button"
        className={[
          'kr-radio__main',
          playing
            ? 'kr-radio__main--active'
            : '',
        ].join(' ')}
        onClick={togglePlay}
      >

        <span className="kr-radio__status">
          {playing
            ? '🟢'
            : '⚫'}
        </span>


        <span className="kr-radio__text">

          <strong>
            {selectedStation.name}
          </strong>

          <small>
            {selectedStation.subtitle}
          </small>

        </span>


        <span className="kr-radio__play">
          {playing
            ? '❚❚'
            : '▶'}
        </span>

      </button>



      <button
        type="button"
        className="kr-radio__stations"
        onClick={() =>
          setOpen(
            (value) => !value,
          )
        }
      >
        ☰
      </button>



      {open && (
        <div className="kr-radio__menu">

          <strong>
            Станции
          </strong>


          {stations.map(
            (station) => (
              <button
                key={
                  station.id
                }
                type="button"
                className={
                  selectedStation.id ===
                  station.id
                    ? 'active'
                    : ''
                }
                onClick={() =>
                  changeStation(
                    station,
                  )
                }
              >

                <span>
                  {selectedStation.id ===
                  station.id
                    ? '●'
                    : '○'}
                </span>


                <span>
                  <b>
                    {station.name}
                  </b>

                  <small>
                    {
                      station.subtitle
                    }
                  </small>
                </span>

              </button>
            ),
          )}

        </div>
      )}


    </div>
  )
}
